import { Component, ElementRef, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  UntypedFormArray,
  FormGroup,
  AbstractControl,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ViewChild } from "@angular/core";
import { Blog } from "../../../models/blog";
import { Category } from "../../../models/category";
import { UntypedFormControl } from "@angular/forms";
import { MessageService, SelectItem } from "primeng/api";
import {
  TYPE_LIST,
  STATE_LIST,
  STATE_PUBLISHED,
  FEATURED_OPTIONS,
  COUNTRIES,
} from "../../constants/constants";
import { CommonModule, DOCUMENT } from "@angular/common";
import { Observable } from "rxjs";
import { SlideshowService } from "src/app/services/slideshow.service";
import { StartupsService } from "src/app/services/startups.service";
import { Startups } from "src/app/models/startups";
import { CategoryService } from "src/app/services/categories.service";
import { UsersService } from "src/app/services/users.service";
import { Users } from "src/app/models/users";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";
import { TabsModule } from "primeng/tabs";

export interface fPairs {
  label: number;
  value: number;
}

import { TopNavComponent } from "src/app/top-nav/top-nav.component";

import { MultiSelectModule } from "primeng/multiselect";

@Component({
  standalone: true,
  selector: "app-likes-form",
  templateUrl: "./likes-form.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    ToastModule,
    ConfirmDialogModule,
    SelectModule,
    TooltipModule,
    TabsModule,
    TopNavComponent,
    MultiSelectModule,
  ],
})
export class LikesFormComponent implements OnInit {
  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;
  pageTitle: string;
  error: string;
  uploadError: string;
  imagePath: any;
  id: number;
  selectedCountry: SelectItem[];
  category: Category;

  blogForm: FormGroup;
  user: Users;
  typeList: any[];
  statePublished: any[];
  stateOptions: any[];
  imageInfos?: Observable<any>;
  selectedDate: Date;
  date: Date;
  basePath: string;
  category_id: any;
  currentUser: any;

  skillsValues: any = [];
  trackByFn(index, item) {
    return item.id;
  }
  element: Startups;
  page = 1;
  pageSize = 10;
  tourTitle: string;
  startupStatus: any;
  categoriesList: Category[] = [];
  selectedCategories: SelectItem[] = [];
  featuredOptions: any[];
  userIdentification: number;
  countriesList: any[];
  startupUrl: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private startupsService: StartupsService,
    private usersService: UsersService,
    private categoryService: CategoryService,
    private router: Router,
    private slideshowService: SlideshowService,
    private route: ActivatedRoute,
  ) {
    this.basePath = window.location.pathname;
    if (this.route.snapshot.queryParamMap.has("page")) {
      this.page = +this.route.snapshot.queryParamMap.getAll("page");
    }
    if (this.route.snapshot.queryParamMap.has("size")) {
      this.pageSize = +this.route.snapshot.queryParamMap.getAll("size");
    }

    if (this.date) {
      this.selectedDate = new Date(this.date);
    }
    this.typeList = TYPE_LIST;
    this.statePublished = STATE_PUBLISHED;
    this.featuredOptions = FEATURED_OPTIONS;
    this.countriesList = COUNTRIES;
    this.stateOptions = STATE_LIST;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
  }

  ngOnInit() {
    this.getCategories();
    const id = this.route.snapshot.paramMap.get("id");

    if (id) {
      this.pageTitle = "Modifica Prodotto";

      this.startupsService.getId(+id).subscribe((res) => {
        this.element = res;
        this.imageInfos = this.slideshowService.getId(+id);

        this.usersService.getId(this.element.user_id).subscribe((res) => {
          this.user = res;
        });

        this.blogForm.patchValue({
          startup_name: res.startup_name,
          startup_headline: res.startup_headline,
          page_url: res.page_url,
          startup_description: res.startup_description,
          startup_technology: res.startup_technology,
          startup_email: res.startup_email,
          startup_url: res.startup_url,
          country: res.country,
          category_id: res.category_id.split(","),
          twitter: res.twitter,
          user_id: res.user_id,
          linkedin: res.linkedin,
          producthunt: res.producthunt,
          id: res.id,
        });
        this.id = res.id;
        this.tourTitle = res.startup_name;
        this.startupStatus = res.status;
        this.imagePath = res.image;
        this.startupUrl = res.startup_url;
        this.userIdentification = res.user_id;
      });
    } else {
      this.pageTitle = "Aggiungi Prodotto";
    }

    this.blogForm = this.fb.group({
      id: [""],
      startup_name: ["", Validators.required],
      startup_headline: ["", Validators.required],
      page_url: ["", Validators.required],
      startup_description: ["", Validators.required],
      startup_technology: [""],
      startup_email: [""],
      startup_url: [""],
      category_id: [""],
      country: [""],
      linkedin: [""],
      twitter: [""],
      producthunt: [""],
      image: [""],
      user_id: [""],
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.blogForm.controls;
  }

  goToUrl(): void {
    window.open(this.startupUrl, "_blank");
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("image").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath = reader.result;
      };
    }
  }

  removeImageFile() {
    this.imagePath = "";
    console.log(this.myInputVariable.nativeElement.files);
    this.myInputVariable.nativeElement.value = "";
    console.log(this.myInputVariable.nativeElement.files);
  }

  public getCategories() {
    const paramsCategories = [];
    this.categoryService.getAll(paramsCategories).subscribe((pData) => {
      this.categoriesList = pData;
    });
  }

  unpublished() {
    const formData = new FormData();

    formData.append("status", "0");
    formData.append("user_published", this.blogForm.get("user_id").value);

    const id = this.blogForm.get("id").value;

    this.startupsService.updateStatus(formData, +id).subscribe(
      (res) => {
        if (res.status == "error") {
          this.uploadError = res.message;
        } else {
          this.messageService.add({
            key: "myKey1",
            severity: "success",
            summary: "Informazioni",
            detail: "Saved successfully",
          });
          //this.router.navigate(['/admin/products']);
          this.ngOnInit();
        }
      },
      (error) => (this.error = error),
    );
  }

  published() {
    const formData = new FormData();

    formData.append("status", "1");
    formData.append("user_published", this.blogForm.get("user_id").value);

    const id = this.blogForm.get("id").value;

    this.startupsService.updateStatus(formData, +id).subscribe(
      (res) => {
        if (res.status == "error") {
          this.uploadError = res.message;
        } else {
          this.messageService.add({
            key: "myKey1",
            severity: "success",
            summary: "Informazioni",
            detail: "Saved successfully",
          });
          //this.router.navigate(['/admin/products']);
          this.ngOnInit();
        }
      },
      (error) => (this.error = error),
    );
  }

  initSkill() {
    var formArray = this.fb.array([]);
    const id = this.route.snapshot.paramMap.get("id");

    this.startupsService.skills(+id).subscribe((res) => {
      this.skillsValues = res;
      this.skillsValues.forEach((e) => {
        formArray.push(
          this.fb.group({
            label: [e.label],
            value: [e.value],
          }),
        );
      });
    });

    /*formArray.push(this.fb.group({
      qty: [''],
      price: ['']
    })) */

    return formArray;
  }

  private createSkillFormGroup(skill: any): UntypedFormGroup {
    return new UntypedFormGroup({
      label: new UntypedFormControl(skill.label),
      value: new UntypedFormControl(skill.value),
    });
  }

  public addSkill(skill: any) {
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get skills() {
    return this.blogForm.get("skills") as UntypedFormArray;
  }

  addQuantity() {
    this.skills.push(this.newQuantity());
  }

  removeQuantity(i: number) {
    this.skills.removeAt(i);
  }

  newQuantity(): UntypedFormGroup {
    return this.fb.group({
      label: "",
      value: "",
    });
  }

  getselectedCategories() {
    this.selectedCategories = this.category_id.split(",");
  }

  onSubmit() {
    const formData = new FormData();

    formData.append("startup_name", this.blogForm.get("startup_name").value);
    formData.append(
      "startup_description",
      this.blogForm.get("startup_description").value,
    );
    formData.append(
      "startup_technology",
      this.blogForm.get("startup_technology").value,
    );
    formData.append(
      "startup_headline",
      this.blogForm.get("startup_headline").value,
    );
    formData.append("page_url", this.blogForm.get("page_url").value);
    formData.append("startup_url", this.blogForm.get("startup_url").value);
    formData.append("startup_email", this.blogForm.get("startup_email").value);
    formData.append("linkedin", this.blogForm.get("linkedin").value);
    formData.append("country", this.blogForm.get("country").value);
    formData.append("twitter", this.blogForm.get("twitter").value);
    formData.append("status", this.blogForm.get("status").value);
    formData.append("producthunt", this.blogForm.get("producthunt").value);
    formData.append("category_id", this.blogForm.get("category_id").value);
    formData.append("image", this.blogForm.get("image").value);
    formData.append("user_id", this.blogForm.get("user_id").value);

    const userId = this.blogForm.get("user_id").value;

    const id = this.blogForm.get("id").value;

    if (id) {
      this.startupsService.update(formData, +id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Informazioni",
              detail: "Saved successfully",
            });
            //this.router.navigate(['/admin/products']);
          }
        },
        (error) => (this.error = error),
      );
    } else {
      this.startupsService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Informazioni",
              detail: "Saved successfully",
            });
            this.router.navigate(["/dashboard/startups"]);
          }
        },
        (error) => (this.error = error),
      );
    }
  }
}
